export default __webpack_public_path__ + "static/gallery-art-design-36e65a738e61dc43d535dc9fe7a82264.jpg";